<div class="section" [formGroup]="billingDataForm">
  <p class="section__title">Provide us some billing information</p>
  <div class="section__item">
    <div class="row">
      <div class="col-5">
        <p class="xen-heading-4 mb-0">Billing information data</p>
        <p class="section__item-subtit">Your data is secure and will only be used for billing purposes</p>
      </div>
      <div class="col-7">
        <div class="pb-4">
          <xen-input
            [label]="'Fiscal company name'"
            [formControlName]="'fiscalCompanyName'"
            [required]="true"
            [type]="'text'"
            [placeholder]="'e.g. Google Inc.'"
            [size]="'medium'"
            [validation]="true"
            [validation_status]="getValidationStatus('fiscalCompanyName', true)"
            [feedback]="
              billingDataForm.get('fiscalCompanyName').dirty
                ? $safeNavigationMigration(billingDataForm.get('fiscalCompanyName').errors?.errorMsg)
                : ''
            "
          ></xen-input>
        </div>
        <div class="pb-4">
          <xen-input
            [label]="'Street Address'"
            [formControlName]="'streetAddress'"
            [required]="true"
            [type]="'text'"
            [placeholder]="'e.g. Sant Joan Street, 9'"
            [size]="'medium'"
            [validation]="true"
            [validation_status]="getValidationStatus('streetAddress', true)"
            [feedback]="
              billingDataForm.get('streetAddress').dirty
                ? $safeNavigationMigration(billingDataForm.get('streetAddress').errors?.errorMsg)
                : ''
            "
          ></xen-input>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="pb-4">
              <xen-select
                [label]="'Country'"
                [formControlName]="'country'"
                [size]="'medium'"
                [id]="'default'"
                [placeholder]="'Select a country'"
                [options]="currentCountries"
                [validation]="true"
                [validation_status]="getValidationStatus('country', true)"
                [feedback]="
                  billingDataForm.get('country').dirty
                    ? $safeNavigationMigration(billingDataForm.get('country').errors?.errorMsg)
                    : ''
                "
              ></xen-select>
            </div>
          </div>
          <div class="col-6">
            <div class="pb-4 d-flex flex-column">
              <label class="form-label">City<span class="is-required text-danger"> *</span></label>
              @if (!citiesLoading) {
                <p-select
                  class="w-full custom-select-city"
                  formControlName="city"
                  [options]="allCitiesByCountry"
                  [filter]="true"
                  optionLabel="name"
                  optionValue="name"
                  filterBy="name"
                  [showClear]="true"
                  placeholder="Select a city"
                  [readonly]="blockCityDropdown"
                  size="small"
                  [disabled]="countryNotSelected"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="45"
                >
                </p-select>
                @if (billingDataForm.get('city')?.invalid && billingDataForm.get('city')?.touched) {
                  <small class="p-error text-danger ms-1"> Please provide your city. </small>
                }
              } @else {
                <p-select class="w-full" [showClear]="false" placeholder="Loading Cities..." size="small"> </p-select>
              }
            </div>
          </div>

          <div class="col-6">
            <div class="pb-4">
              <xen-input
                [label]="'Zip Code'"
                [formControlName]="'zipCode'"
                [required]="true"
                [type]="'text'"
                [placeholder]="'e.g. 07005'"
                [size]="'medium'"
                [validation]="true"
                [validation_status]="getValidationStatus('zipCode', true)"
                [feedback]="
                  billingDataForm.get('zipCode').dirty
                    ? $safeNavigationMigration(billingDataForm.get('zipCode').errors?.errorMsg)
                    : ''
                "
              ></xen-input>
            </div>
          </div>
          <div class="col-6">
            <div class="pb-4">
              <xen-input
                [label]="'VAT / ID Number'"
                [formControlName]="'vatIdNumber'"
                [required]="true"
                [type]="'text'"
                [placeholder]="'e.g. X12345678'"
                [size]="'medium'"
                [validation]="true"
                [validation_status]="getValidationStatus('vatIdNumber', true)"
                [feedback]="
                  billingDataForm.get('vatIdNumber').dirty
                    ? $safeNavigationMigration(billingDataForm.get('vatIdNumber').errors?.errorMsg)
                    : ''
                "
              ></xen-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="d-flex justify-content-end gap-2">
        @if (isEditing) {
          <xen-btn
            class="d-block"
            [type]="'flat'"
            [size]="'large'"
            label="Cancel"
            [icon]="false"
            [skin]="'gray'"
            [loading]="isLoading"
            (clicked)="cancelChanges()"
          ></xen-btn>
        }
        <xen-btn
          class="d-block"
          [type]="'primary'"
          [size]="'large'"
          [label]="buttonName"
          [icon]="true"
          [icon_placement]="'right'"
          [icon_snippet]="'far fa-angle-right'"
          [skin]="'blue'"
          (clicked)="submitBilling()"
          [disabled]="isButtonDisabled()"
          [loading]="isLoading"
        ></xen-btn>
      </div>
    </div>
  </div>
</div>
